<template>
    <div class="wrapper landing-page">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/tjn-bck.jpg')">
            </parallax>
            <div class="content-center">
                <h1 class="title">{{webSiteBilgileri.PodCastAdi}}</h1>
                <h5 class="description">{{webSiteBilgileri.Slogan}}</h5>
                <div class="text-center">
                    <a href="https://www.instagram.com/tijenhoca/" class="btn btn-primary btn-icon  btn-round">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="https://twitter.com/tijentangulse" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.facebook.com/pages/Tijen-Hoca/208586643077901" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-facebook"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="features-5">
            <div class="container">
                <div class="row">
                    <div class="col col-sm-2 col-md-2 col-12">
                        <div class="tablet-container">
                            <img v-lazy="frontend_address + webSiteBilgileri.podcast_image.url" />
                        </div>
                    </div>
                        <div class="col col-sm-10 col-md-10 col-12 text-center">
                            <h2 class="title">Duyurular</h2>
                            <table class="table table-striped table-primary table-responsive" style="max-height: 500px; overflow: auto">
                                <thead>
                                <tr>
                                    <th scope="col">Tarih</th>
                                    <th scope="col">Duyuru</th>
                                    <th scope="col">Detay</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="p in duyurulars" :key="p.id">
                                    <td style="min-width: 400px">{{ p.Tarih }}</td>
                                    <td style="min-width: 400px">{{ p.Baslik }}</td>
                                    <td>
                                        <router-link :to="'/duyuru/'+p.id">Gör</router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Tabs, TabPane } from '@/components';
  import gql from "graphql-tag";
  export default {
    name: 'landing-page',
    bodyClass: 'landing-page',
    components: {
      Card,
      Tabs,
      TabPane,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        form: {
          firstName: '',
          email: '',
          message: '',
        },
        webSiteBilgileri: {SiteAdi: '', KatildigimIsler:[],podcast_image:{}},
        frontend_address: process.env.VUE_APP_FRONTEND_ADDRESS,
        duyurulars: []
      }
    },
    apollo: {
      webSiteBilgileri: gql`
      query webSiteBilgileri {
        webSiteBilgileri {
          id
          SiteAdi
          tags
          PodCastAdi
          PodCastKonusu
          Slogan
          created_at
          updated_at
          podcast_image {
            url
          }
          KatildigimIsler {
            id
            Baslik
            KisaAciklama
            icon
            ArkaPlanResmi {
              url
              previewUrl
            }
            link
          }
        }
      }
    `,
      duyurulars: gql`
       query duyurulars  {
          duyurulars{
            id
            Baslik
            Tarih
           }
      }
    `
    }
  }
</script>
<style>
</style>
